import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from './SearchBar.presets';

const StyledSearchBarWrapper = styled.div`
  input {
    caret-color: ${({ theme }) => theme.Color.System.Primary} !important;
    color: ${({ theme }) => theme.Color.Neutrals.Gray} !important;
  }

  input::placeholder {
    color: ${({ theme }) => theme.Color.Neutrals.Gray} !important;
  }

  span .ant-input-affix-wrapper {
    background-color: ${({ theme }) => theme.Color.Neutrals.Paper} !important;
    border-color: ${({ theme }) => theme.Color.Neutrals.Gray} !important;
  }

  .ant-input-clear-icon {
    display: inline-flex !important;
  }
  .ant-input-search-button {
    display: inline-flex !important;
    align-items: center !important;
  }

  .ant-input-group-addon button {
    background-color: ${({ theme }) => theme.Color.System.Primary} !important;
  }
`;

const StyledAutoComplete = styled.div<{
  isMobile: boolean;
  isFixedHeight: boolean;
}>`
  height: ${({ isMobile, isFixedHeight }) =>
    !isFixedHeight
      ? 'auto'
      : utils.rem(
          isMobile
            ? PRESETS.searchResult.autoCompleteHeight.mobile
            : PRESETS.searchResult.autoCompleteHeight.desktop
        )};
  .ant-select-show-search {
    width: 100%;
  }

  && .ant-select-dropdown {
    border-radius: 0 !important;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important;
    background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  }

  & .ant-select-item-option-content,
  .ant-select-item-option-content span {
    color: ${({ theme }) => theme.Color.Neutrals.Text};
  }

  & .ant-select-item-option-active {
    background-color: ${({ theme }) => theme.Color.Neutrals.Light} !important;
  }
`;

const StyledLoaderWrapper = styled.div`
  text-align: center;
  .anticon-loading,
  .anticon-spin ant-spin-dot {
    font-size: ${({ theme }) => utils.rem(theme.Spacing.Size.Large)}!important;
  }
`;

export const SearchBarStyles = {
  StyledSearchBarWrapper,
  StyledAutoComplete,
  StyledLoaderWrapper,
};
